/**
 * useSEOWidgets — fetcha /api/seo/widgets para a métrica ativa.
 *
 * Re-busca quando metric, período ou cliente mudam. Espelha
 * useDashboardWidgets — separado p/ permitir evolução independente
 * (ex.: incorporar dados do GSC sem afetar o dashboard pago).
 */

import { useState, useEffect, useRef, useCallback } from 'react'
import { getSEOWidgets, setSelectedClientId } from '../db/api.js'

export function useSEOWidgets(startDate, endDate, clientId, metric) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const requestIdRef = useRef(0)

  const refetch = useCallback(async () => {
    if (!startDate || !endDate) return
    const requestId = ++requestIdRef.current
    setLoading(true)
    setError(null)
    try {
      setSelectedClientId(clientId)
      const result = await getSEOWidgets(startDate, endDate, metric)
      if (requestId !== requestIdRef.current) return
      setData(result)
    } catch (err) {
      if (requestId !== requestIdRef.current) return
      console.error('[useSEOWidgets] fetch error:', err)
      setError(err.message || 'Erro ao carregar widgets SEO')
    } finally {
      if (requestId === requestIdRef.current) setLoading(false)
    }
  }, [startDate, endDate, clientId, metric])

  useEffect(() => { refetch() }, [refetch])

  return { data, loading, error, refetch }
}
